import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { Helmet } from 'react-helmet-async';

import ErrorMessage from '../components/ErrorMessage';
import ChangePasswordAfterRestoreForm from '../forms/ChangePasswordAfterRestoreForm';
import { changePasswordAfterRestore } from '../actions/app';


const ChangePasswordAfterRestorePage = (props) => {
  const { changePasswordAfterRestore } = props;
  const { uid, token } = useParams();
  return (
    <div className="full-height-wrap section-grey">
      <Helmet>
        <title>Восстановление пароля | Jobs Widget</title>
      </Helmet>
      <h2 className="auth-title">Восстановление пароля</h2>
      <div className="auth-content">
        <ChangePasswordAfterRestoreForm
          onSubmit={({ newPassword, reNewPassword }) => changePasswordAfterRestore(
            newPassword,
            reNewPassword,
            uid,
            token,
          )}
        />
        <ErrorMessage errorName="changePasswordAfterRestoreError" />
      </div>
    </div>
  );
};

ChangePasswordAfterRestorePage.propTypes = {
  changePasswordAfterRestore: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  changePasswordAfterRestore: (newPassword, reNewPassword, uid, token) => dispatch(
    changePasswordAfterRestore(newPassword, reNewPassword, uid, token),
  ),
});

export default connect(null, mapDispatchToProps)(ChangePasswordAfterRestorePage);
